import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented imports later.
  // fetchGetReleaseReadinessTrends,
  getReleaseDetails,
  // getReleaseReadinessDetails,
  getSprintList,
  // getTaskCount,
  // getAllStoryPointsCommittedAndCompleted,
  // fetchStatusCount,
  getProjectList,
  // getFetchOpenPullRequests,
  // fetchGetClosedPRs,
  // fetchLeadTimeForChanges,
  // getMergedPRsWithoutReview,
  // fetchGetTotalPRs,
  getRepoList,
  // getPRsSize,
  // getGitCycleTime,
  // getApprovalRate,
  // getBugClassification,
  // getDefectDensity,
  // getVelocity,
  // getDefectRejection,
  // getActualStoryPoints,
  // getDefectRemovalEfficiency,
  // getTimeToFix,
  // getIterationTime,
  // getCostOfFixingDefects,
  // getDoraMetrics,
  // getDefectLekageAnalysis,
  // getStoryPointData,
  // getjiraTableData,
  // getSprintLength,
  // getStoryChurnData,
  // getStoryChurnExcludingBugs,
  // fetchJiraStatusByDeveloper,
  // getOpenPRsData,
  // getMergedPRsWithoutReviewData,
  // getStandupBurndown,
  // getDailyBurnup,
  getAllOrgsListAPI,
  // getCycleTime,
  // getSprintCompleteDate,
  // getAvailableHours,
  // getUserList,
  // getBurndownVelocity,
  // getQAInsightsBugs,
  // getQAInsightsTests,
  // getQARefrence,
  // getBurndownData,
  // getReleaseBurndownData,
  getProjectManagementData,
  getStandupDashboardData,
  getGitDashboardData,
  getCXODashboardData,
  getBoardList,
  APP_STRINGS,
  isCreatedDateFilterType,
  isClickupListBoardTypeFromSession,
} from '../constants';
import { getBoardLabels, storeBoardInSession } from './boardUtils';
import {
  canAccessPath,
  getDefaultAllowedPath,
  refreshScopedPermissions,
} from './permissions';
import { resolveReleaseIdAfterSync, resolveSprintIdAfterSync } from './syncStatusUtils';
import {
  setMultiProjectCompanyId,
  setMultiProjectFilters,
} from '../store/MultiProjectSlice/multiProjectSlice';
import { resolveStandupHoursBasedProject } from './capacityPlanningUtils';
import {
  setStatusCountData,
  setStoryPointsData,
  setTaskCountData,
  setSprintList,
  setReleasesList,
  setSelectedProject,
  setSelectedSprint,
  setIsProjectOpen,
  setSelectedRelease,
  setIsSprintOpen,
  setVelocityData,
  setSprint,
  setRelease,
  setSelectedTypeValue,
  setRepoList,
  setLoading,
  setLoadingEngMetrics,
  setSelectedSprintEndDate,
  setSelectedReleaseDate,
  setBugClassification,
  setDefectDensity,
  setDefectRejection,
  setTimeToFix,
  setDefectRemovalEfficiency,
  setRepositoryProvider,
  setCostOfFixingDefect,
  setDefectLeakageAnalysis,
  setGetStoryPointData,
  setJiraTableData,
  setSprintLength,
  setStoryChurnData,
  setJiraStatusByDeveloper,
  setSelectedDeveloperName,
  setStandupBurndown,
  setDailyWiseStatusCount,
  setSelectedOrganization,
  setOrganizationList,
  setIsOrganizationOpen,
  setProjectList,
  setCycleTime,
  setSprintCompleteDate,
  setAvailableHours,
  setUserList,
  setBurndownVelocity,
  setQAInsightsBugsData,
  setQAInsightsTestsData,
  setQAReferenceData,
  setStandupVisibility,
  setBurndownData,
} from '../store/JiraSlices/jiraSlice';
import {
  setClosedPRs,
  setTotalPRs,
  setOpenPRs,
  setMergedWithoutReviewPRs,
  setPRSize,
  setGitCycleTime,
  setApprovalRate,
  setSelectedRepository,
  setIterationTime,
  setLeadTimeChanges,
  setGetDoraData,
  setStandupOpenPRsData,
  setStandupMergedPRsData,
} from '../store/GitSlices/gitSlices';
import {
  addReleaseReadinessTrendsData,
  addReleaseReadinessData,
  setActualStoryPoints,
  setDailyBurnup,
} from '../store/CXOSlices/cxoSlice';

import { reset as resetGit } from '../store/GitSlices/gitSlices';
import { reset as resetJira } from '../store/JiraSlices/jiraSlice';
import { reset as resetCXO } from '../store/CXOSlices/cxoSlice';
import { addData } from '../store/sonarqube/sonarQubeGitSlice';
import { reset as resetSonarQubeData } from '../store/sonarqube/sonarQubeGitSlice';
import store from '../store/store';
const TECH_QUALITY_PATH = '/techQuality';
const DASHBOARD_PATH = '/dashboard';
const STANDUP_PATH = '/standUp';
const JIRA_PATH = '/jiraDashboard';
const GIT_PATH = '/gitDashboard';
const RELEASE_DASHBOARD_PATH = '/release';
const INTEGRATION_PATH = '/integration';

/** Clear loaders when workspace has no integrated project (user can stay and switch org). */
const clearLoadersNoProject = (dispatch) => {
  dispatch(setLoading(false));
  dispatch(setLoadingEngMetrics(false));
};

/** One-time UX when switching to an unintegrated workspace — toast + Integration. */
const redirectWorkspaceNotIntegrated = (dispatch, navigate, currentPath) => {
  clearLoadersNoProject(dispatch);
  toast.info('Workspace is not integrated', {
    className: 'bg-secondary-500 text-white',
  });
  if (currentPath !== INTEGRATION_PATH) {
    navigate(INTEGRATION_PATH, { replace: true });
  }
};

import {
  pickDefaultRelease,
  pickDefaultSprint,
  shouldDefaultToRelease,
  resolveDefaultSprintOrRelease,
  pickDefaultProjectForBootstrap,
  resolveIntegratedProject,
} from './defaultSelectionUtils';

/** Redux is the source of truth for developer filter; fall back to sessionStorage when Redux lags. */
const getDeveloperQueryParam = () => {
  const dev = store.getState()?.jira?.selectedDeveloperName;
  if (dev != null && dev !== '') {
    const value = typeof dev === 'object' ? dev?.value : dev;
    if (value) return value;
  }
  const fromSession = sessionStorage.getItem('developer');
  return fromSession || undefined;
};

// Deduplicate refreshToken-driven refetch across multiple CommonFunction() instances
// (each page mounts its own hook; React still runs mount effects even when Redux refreshToken is unchanged).
let lastCompletedJiraRefreshTokenEffectKey = null;
let jiraRefreshTokenEffectInFlightKey = null;
let jiraRefreshTokenEffectGeneration = 0;

/** Clear dedupe state so the next bumpRefreshToken always refetches dashboard data (e.g. after Jira sync). */
export function clearJiraRefreshTokenDedupe() {
  lastCompletedJiraRefreshTokenEffectKey = null;
  jiraRefreshTokenEffectInFlightKey = null;
}

/** Session key: projectId the current boardId belongs to (avoids stale board after project change). */
const BOARD_SCOPE_PROJECT_KEY = 'boardScopeProjectId';

/** Ensure boardId/boardType exist in session for a project (first board wins). */
const ensureBoardForProject = async (companyId, projectId) => {
  const scopedProjectId = String(projectId || '');
  const existingBoardId = sessionStorage.getItem('boardId');
  const boardScopeProjectId = sessionStorage.getItem(BOARD_SCOPE_PROJECT_KEY);
  if (existingBoardId && boardScopeProjectId === scopedProjectId) {
    return {
      boardId: existingBoardId,
      boardType:
        sessionStorage.getItem('boardType') ||
        sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
        '',
    };
  }
  // Board set by page UI without scope key — claim for this project (do not wipe).
  if (existingBoardId && !boardScopeProjectId) {
    sessionStorage.setItem(BOARD_SCOPE_PROJECT_KEY, scopedProjectId);
    return {
      boardId: existingBoardId,
      boardType:
        sessionStorage.getItem('boardType') ||
        sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
        '',
    };
  }
  if (existingBoardId && boardScopeProjectId && boardScopeProjectId !== scopedProjectId) {
    sessionStorage.removeItem('boardId');
    sessionStorage.removeItem(APP_STRINGS.SESSION_BOARD_ID);
    sessionStorage.removeItem(APP_STRINGS.SESSION_SELECTED_BOARD);
    sessionStorage.removeItem(APP_STRINGS.SESSION_BOARD_NAME);
    sessionStorage.removeItem(BOARD_SCOPE_PROJECT_KEY);
  }
  if (!companyId || !projectId) {
    return { boardId: '', boardType: '' };
  }
  try {
    const response = await getBoardList(companyId, projectId);
    const boards = Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response)
        ? response
        : [];
    const firstBoard = boards[0];
    if (!firstBoard) {
      return { boardId: '', boardType: '' };
    }
    const boardId = String(firstBoard.id || firstBoard._id || '');
    const boardType = String(firstBoard.type || firstBoard.boardType || '');
    sessionStorage.setItem('boardId', boardId);
    storeBoardInSession(
      boardId,
      firstBoard.name || firstBoard.boardName || '',
      boardType,
    );
    const normalized = boardType.toLowerCase();
    sessionStorage.setItem(
      'boardType',
      normalized.includes('azure') ? 'azure-board' : normalized,
    );
    sessionStorage.setItem(BOARD_SCOPE_PROJECT_KEY, scopedProjectId);
    return { boardId, boardType };
  } catch (err) {
    console.error('Failed to resolve default board for project:', err);
    return { boardId: '', boardType: '' };
  }
};

/** Prefer ClickUp session board type so milestone defaults stay ClickUp-aware. */
const resolveNavBoardType = () => {
  if (isClickupListBoardTypeFromSession()) {
    return APP_STRINGS.CLICKUP_LIST_KEBAB;
  }
  return (
    sessionStorage.getItem('boardType') ||
    sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
    ''
  );
};

export const CommonFunction = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const refreshToken = useSelector((state) => state?.jira?.refreshToken);
  const orgListFetchInFlightRef = useRef(false);
  let repo = sessionStorage.getItem('repo');
  const isTechQualityPage = location?.pathname === TECH_QUALITY_PATH;
  const isReleaseDashboardPage = location?.pathname === RELEASE_DASHBOARD_PATH;

  // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
  // const getChurnApi = () => {
  //   const exclude = sessionStorage.getItem('excludeBugsInChurn') === 'true';
  //   return exclude ? getStoryChurnExcludingBugs : getStoryChurnData;
  // };

  const fetchData = async (apiCall, action, params) => {
    try {
      const response = await apiCall(params);
      const isQARefrenceCall =
        action === setQAReferenceData ||
        (typeof apiCall === 'function' && apiCall.toString().includes('getQARefrence'));
      if (isQARefrenceCall) {
        if (
          !response ||
          !response.data ||
          (typeof response.data === 'object' && Object.keys(response.data).length === 0)
        ) {
          dispatch(action(null));
          return;
        }
      }
      dispatch(action(response.data));
    } catch (error) {
      const isQARefrenceCall =
        action === setQAReferenceData ||
        (typeof apiCall === 'function' && apiCall.toString().includes('getQARefrence'));

      if (isQARefrenceCall) {
        dispatch(action(null));
      }
    }
  };
  const getRepositoryPlatform = (repos = []) => {
    if (!Array.isArray(repos) || repos.length === 0) return 'unknown';

    const isGitLab = repos.some((repo) => typeof repo === 'string' && repo.includes('gitlab.com'));
    const isGitHub = repos.some((repo) => typeof repo === 'string' && repo.includes('github.com'));

    if (isGitLab) return 'GitLab';
    if (isGitHub) return 'GitHub';
    return 'unknown';
  };

  useEffect(() => {
    const companyId = sessionStorage.getItem('companyId');
    if (!companyId) return;
    const cachedOrgs = store.getState()?.jira?.organizationList;
    if (cachedOrgs?.length > 0) return;
    if (orgListFetchInFlightRef.current) return;

    orgListFetchInFlightRef.current = true;
    Promise.resolve()
      .then(async () => {
        const organizations = await getAllOrgsListAPI();
        if (Array.isArray(organizations) && organizations.length > 0) {
          dispatch(setOrganizationList(organizations));
        }
      })
      .catch((error) => {
        console.error('Error fetching organization list:', error);
      })
      .finally(() => {
        orgListFetchInFlightRef.current = false;
      });
  }, [dispatch]);

  // This runs once on mount to restore session selections; intentionally not re-run.
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');

    if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      sessionStorage.removeItem('developer');
      dispatch(setSelectedDeveloperName(null));

      const fetchAndSetData = async () => {
        const storedProjectId = sessionStorage.getItem('projectId');
        const storedSprintId = sessionStorage.getItem('sprintId');
        const storedSprintName = sessionStorage.getItem('sprintName');
        const storedReleaseId = sessionStorage.getItem('releaseId');
        const storedReleaseName = sessionStorage.getItem('releaseName');
        const storedRepo = sessionStorage.getItem('repo');
        const storedTypeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
        const storedTypeValueLabel = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
        const orgId = sessionStorage.getItem('orgId');
        const orgName = sessionStorage.getItem('orgName');

        dispatch(
          setSelectedOrganization({
            selectedOrgName: orgName,
            selectedOrgId: orgId,
          }),
        );

        const existingState = store.getState()?.jira;
        let projectList = existingState?.projectList;

        if (!Array.isArray(projectList) || projectList.length === 0) {
          try {
            const projects = await getProjectList();
            projectList = Array.isArray(projects?.data)
              ? projects.data
              : Array.isArray(projects)
                ? projects
                : [];
            if (projectList.length > 0) {
              dispatch(setProjectList(projectList));
            }
          } catch (error) {
            console.error('Error fetching project list:', error);
            projectList = [];
          }
        }

        const resolvedProject = resolveIntegratedProject(projectList, storedProjectId);
        if (resolvedProject) {
          const repositoryPlatform = getRepositoryPlatform(resolvedProject?.repos);
          dispatch(setRepositoryProvider({ repositoryProvider: repositoryPlatform }));

          const activeProjectId = resolvedProject._id;
          const activeProjectName = resolvedProject.name;
          const projectChanged = String(activeProjectId) !== String(storedProjectId || '');

          if (projectChanged) {
            sessionStorage.setItem('projectId', activeProjectId);
            sessionStorage.setItem('projectName', activeProjectName);
            sessionStorage.removeItem('boardId');
            sessionStorage.removeItem(APP_STRINGS.SESSION_BOARD_ID);
            sessionStorage.removeItem(APP_STRINGS.SESSION_SELECTED_BOARD);
            sessionStorage.removeItem(BOARD_SCOPE_PROJECT_KEY);
            sessionStorage.removeItem('sprintId');
            sessionStorage.removeItem('sprintName');
            sessionStorage.removeItem('releaseId');
            sessionStorage.removeItem('releaseName');
            sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
            sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
          }

          // setSelectedProject resets sprint/release in Redux — always re-bootstrap scope after it.
          dispatch(
            setSelectedProject({
              selectedProjectName: activeProjectName,
              selectedProjectId: activeProjectId,
            }),
          );

          if (!isTechQualityPage) {
            const needsScopeBootstrap =
              projectChanged ||
              (!storedSprintId && !storedReleaseId && storedTypeValue !== APP_STRINGS.VALUE_BACKLOG);
            if (needsScopeBootstrap) {
              const companyId = sessionStorage.getItem('companyId') || orgId;
              await ensureBoardForProject(companyId, activeProjectId);
              await handleProject(
                activeProjectId,
                sessionStorage.getItem('boardType') ||
                  sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
                  '',
                dispatch,
              );
              return;
            }

            // Board from login may lack boardScopeProjectId — ensure before sprint APIs.
            const companyId = sessionStorage.getItem('companyId') || orgId;
            await ensureBoardForProject(companyId, activeProjectId);

            const hasSprintsInRedux = existingState?.sprintList?.length > 0;
            const hasReleasesInRedux = existingState?.releasesList?.length > 0;
            const hasReposInRedux = existingState?.repoList?.length > 0;

            if (!hasSprintsInRedux) {
              fetchData(getSprintList, setSprintList, {
                projectId: activeProjectId,
                boardId: sessionStorage.getItem('boardId'),
              });
            }
            if (!hasReleasesInRedux) {
              fetchData(getReleaseDetails, setReleasesList, {
                projectId: activeProjectId,
                boardId: sessionStorage.getItem('boardId'),
              });
            }
            if (!hasReposInRedux) {
              fetchData(getRepoList, setRepoList, {
                companyId: sessionStorage.getItem('companyId'),
                projectId: activeProjectId,
              });
            }
          }
        }

        if (!resolvedProject) {
          // Only clear when we successfully loaded a list and nothing is Integration-selected.
          // Keep session project if the list failed to load (avoid wiping login defaults).
          if (Array.isArray(projectList) && projectList.length > 0) {
            sessionStorage.removeItem('projectId');
            sessionStorage.removeItem('projectName');
            dispatch(setSelectedProject({ selectedProjectName: '', selectedProjectId: '' }));
          }
        }

        if (resolvedProject && !isTechQualityPage) {
          if (isReleaseDashboardPage) {
            if (storedReleaseId && storedReleaseName) {
              dispatch(
                setSelectedRelease({
                  selectedReleaseId: storedReleaseId,
                  selectedReleaseName: storedReleaseName,
                }),
              );
            }
          } else {
            const effectiveType =
              storedTypeValue ||
              (storedReleaseId
                ? APP_STRINGS.VALUE_RELEASE
                : storedSprintId
                  ? APP_STRINGS.VALUE_SPRINT
                  : '');

            if (effectiveType === APP_STRINGS.VALUE_BACKLOG) {
              await handleBacklogForStandup();
            } else if (storedSprintId && effectiveType !== APP_STRINGS.VALUE_RELEASE) {
              dispatch(
                setSelectedSprint({
                  selectedSprintId: storedSprintId,
                  selectedSprintName: storedSprintName || '',
                }),
              );
              await handleSprint(storedSprintId);
            } else if (storedReleaseId) {
              dispatch(
                setSelectedRelease({
                  selectedReleaseId: storedReleaseId,
                  selectedReleaseName: storedReleaseName || '',
                }),
              );
              await handleRelease(storedReleaseId);
            }

            if (storedRepo) {
              dispatch(setSelectedRepository(storedRepo));
            }

            if (storedTypeValue && storedTypeValueLabel) {
              const normalizedTypeValue =
                storedTypeValue === APP_STRINGS.LEGACY_VALUE_DATE_RANGE
                  ? APP_STRINGS.VALUE_DATE_RANGE
                  : storedTypeValue;
              const normalizedTypeLabel =
                storedTypeValueLabel === APP_STRINGS.LEGACY_VALUE_DATE_RANGE
                  ? APP_STRINGS.VALUE_DATE_RANGE
                  : storedTypeValueLabel;
              if (normalizedTypeValue !== storedTypeValue) {
                sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, normalizedTypeValue);
              }
              if (normalizedTypeLabel !== storedTypeValueLabel) {
                sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, normalizedTypeLabel);
              }
              dispatch(
                setSelectedTypeValue({
                  selectedValueLabel: normalizedTypeLabel,
                  selectedValue: normalizedTypeValue,
                }),
              );
            }
          }
        }
      };

      fetchAndSetData();
    }

    const handleUnload = () => {
      sessionStorage.removeItem('hasRefreshed');
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Select back to active sprint when we move from techquality page to any other page
  useEffect(() => {
    const currPath = location.pathname;
    const lastPath = sessionStorage.getItem('lastVisitedPath') || '';
    const projectId = sessionStorage.getItem('projectId');
    const boardId = sessionStorage.getItem('boardId');
    const sprintId = sessionStorage.getItem('sprintId');

    const isLeavingTechQuality = lastPath === TECH_QUALITY_PATH && currPath !== TECH_QUALITY_PATH;
    const releaseId = sessionStorage.getItem('releaseId');
    const typeValueForNav = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
    const companyIdForNav =
      sessionStorage.getItem('companyId') || sessionStorage.getItem('orgId') || '';
    const isDashboardNeedingSprint =
      currPath === DASHBOARD_PATH && projectId && !sprintId && !releaseId;
    const isStandupNeedingSprint =
      currPath === STANDUP_PATH &&
      projectId &&
      !sprintId &&
      !releaseId &&
      typeValueForNav !== APP_STRINGS.VALUE_BACKLOG;
    // Admin pages do not mount CommonFunction, so lastVisitedPath may be empty after login→Admin.
    const cameFromAdmin = String(lastPath).startsWith('/admin');
    const cameFromIntegration = lastPath === INTEGRATION_PATH;
    const isFirstStandupLand =
      currPath === STANDUP_PATH && (!lastPath || lastPath === '/' || lastPath === '/login');
    const reduxProjectId = store.getState()?.jira?.selectedProjectId;
    const isStandupScopeIncomplete =
      currPath === STANDUP_PATH &&
      Boolean(companyIdForNav) &&
      (!projectId ||
        !reduxProjectId ||
        (!sprintId && !releaseId && typeValueForNav !== APP_STRINGS.VALUE_BACKLOG));
    // Admin (and other pages) never run CommonFunction — arriving on Standup with org
    // but no project must pick the Integration default and load sprint/release.
    const isStandupNeedingProject =
      currPath === STANDUP_PATH &&
      Boolean(companyIdForNav) &&
      (!projectId || !reduxProjectId);
    // After Admin, even if login seeded sprint IDs, Standup cards are usually missing — force scope.
    const shouldBootstrapStandupDefaults =
      currPath === STANDUP_PATH &&
      Boolean(companyIdForNav) &&
      (isStandupNeedingProject ||
        isStandupNeedingSprint ||
        cameFromAdmin ||
        cameFromIntegration ||
        (isFirstStandupLand && isStandupScopeIncomplete));

    if (currPath === RELEASE_DASHBOARD_PATH) {
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // Login → Admin → Standup (first visit): always resolve project + default sprint/release.
    // Slower networks (dev) often miss one-shot bootstraps that work locally.
    if ((cameFromAdmin || cameFromIntegration) && currPath === STANDUP_PATH && companyIdForNav) {
      (async () => {
        try {
          dispatch(setLoading(true));
          dispatch(setLoadingEngMetrics(true));

          let projectList = store.getState()?.jira?.projectList;
          if (!Array.isArray(projectList) || projectList.length === 0) {
            let projectsRes = null;
            for (let i = 0; i < 3; i += 1) {
              try {
                projectsRes = await getProjectList();
                break;
              } catch (err) {
                if (i === 2) throw err;
                await new Promise((r) => setTimeout(r, 400 * (i + 1)));
              }
            }
            projectList = Array.isArray(projectsRes?.data)
              ? projectsRes.data
              : Array.isArray(projectsRes)
                ? projectsRes
                : [];
            if (projectList.length > 0) {
              dispatch(setProjectList(projectList));
            }
          }

          const candidateId = String(projectId || reduxProjectId || '');
          let resolved =
            (candidateId &&
              projectList.find((p) => String(p?._id) === candidateId)) ||
            pickDefaultProjectForBootstrap(projectList);
          if (!resolved?._id) {
            if (candidateId) {
              resolved = {
                _id: candidateId,
                name: sessionStorage.getItem('projectName') || '',
              };
            } else {
              dispatch(setLoading(false));
              dispatch(setLoadingEngMetrics(false));
              return;
            }
          }

          const activeProjectId = String(resolved._id);
          const activeProjectName =
            resolved.name || sessionStorage.getItem('projectName') || '';
          sessionStorage.setItem('projectId', activeProjectId);
          sessionStorage.setItem('projectName', activeProjectName);
          dispatch(
            setSelectedProject({
              selectedProjectName: activeProjectName,
              selectedProjectId: activeProjectId,
            }),
          );
          try {
            await refreshScopedPermissions(companyIdForNav, activeProjectId);
          } catch (permErr) {
            console.error('Failed to refresh permissions after Admin/Integration→Standup:', permErr);
          }

          await ensureBoardForProject(companyIdForNav, activeProjectId);
          await handleProject(
            activeProjectId,
            resolveNavBoardType() ||
              sessionStorage.getItem('boardType') ||
              sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
              '',
            dispatch,
          );
        } catch (err) {
          console.error('Error bootstrapping Standup after Admin/Integration:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // When navigating from Release Dashboard to Standup, fetch standup-specific data
    const isLeavingReleaseDashboardToStandup =
      lastPath === RELEASE_DASHBOARD_PATH && currPath === STANDUP_PATH;
    // QMetry360 / Eng Metrics Sprint payload ≠ Standup cards — always re-fetch Standup APIs.
    const isLeavingDashboardToStandup =
      currPath === STANDUP_PATH &&
      (lastPath === DASHBOARD_PATH || lastPath === JIRA_PATH || lastPath === GIT_PATH);
    if (
      (isLeavingReleaseDashboardToStandup || isLeavingDashboardToStandup) &&
      projectId
    ) {
      const typeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
      (async () => {
        try {
          await ensureBoardForProject(companyIdForNav, projectId);
          // Sprint list may be empty after org/project switch on dashboard — refresh before select.
          const liveSprints = store.getState()?.jira?.sprintList;
          if (!Array.isArray(liveSprints) || liveSprints.length === 0) {
            const sprints = (await getSprintList())?.data || [];
            if (sprints.length > 0) dispatch(setSprintList(sprints));
          }
          const liveReleases = store.getState()?.jira?.releasesList;
          if (!Array.isArray(liveReleases) || liveReleases.length === 0) {
            const releases = (await getReleaseDetails())?.data || [];
            if (releases.length > 0) dispatch(setReleasesList(releases));
          }

          if (typeValue === APP_STRINGS.VALUE_BACKLOG) {
            await handleBacklogForStandup();
          } else if (typeValue === APP_STRINGS.VALUE_RELEASE && releaseId) {
            const releases = store.getState()?.jira?.releasesList || [];
            const releaseOk = releases.some((r) => String(r._id) === String(releaseId));
            if (releaseOk) {
              await handleReleaseForStandup(releaseId);
            } else {
              const selection = resolveDefaultSprintOrRelease({
                boardType: resolveNavBoardType(),
                sprintList: store.getState()?.jira?.sprintList || [],
                releaseList: releases,
                storedSprintId: sessionStorage.getItem('sprintId'),
                storedReleaseId: releaseId,
              });
              if (selection.mode === 'release' && selection.release) {
                await handleReleaseForStandup(selection.release._id);
              } else if (selection.mode === 'sprint' && selection.sprint) {
                await handleSprintForStandup(selection.sprint._id);
              } else {
                dispatch(setLoading(false));
                dispatch(setLoadingEngMetrics(false));
              }
            }
          } else if (sprintId) {
            const sprints = store.getState()?.jira?.sprintList || [];
            const sprintOk = sprints.some((s) => String(s._id) === String(sprintId));
            if (sprintOk) {
              await handleSprintForStandup(sprintId);
            } else if (isClickupListBoardTypeFromSession()) {
              // ClickUp milestones: prefer stored id, else latest by endDate (not Jira active/current).
              const sprintToUse =
                sprints.find((s) => String(s._id) === String(sprintId)) ||
                [...sprints].sort(
                  (a, b) => new Date(b.endDate || 0) - new Date(a.endDate || 0),
                )[0];
              if (sprintToUse) {
                await handleSprintForStandup(sprintToUse._id);
              } else {
                dispatch(setLoading(false));
                dispatch(setLoadingEngMetrics(false));
              }
            } else {
              const selection = resolveDefaultSprintOrRelease({
                boardType: resolveNavBoardType(),
                sprintList: sprints,
                releaseList: store.getState()?.jira?.releasesList || [],
                storedSprintId: sprintId,
              });
              if (selection.mode === 'release' && selection.release) {
                await handleReleaseForStandup(selection.release._id);
              } else if (selection.mode === 'sprint' && selection.sprint) {
                await handleSprintForStandup(selection.sprint._id);
              } else {
                dispatch(setLoading(false));
                dispatch(setLoadingEngMetrics(false));
              }
            }
          } else if (releaseId) {
            await handleReleaseForStandup(releaseId);
          } else {
            dispatch(setLoading(true));
            dispatch(setLoadingEngMetrics(true));
            const sprints = store.getState()?.jira?.sprintList || [];
            const releases = store.getState()?.jira?.releasesList || [];
            if (isClickupListBoardTypeFromSession()) {
              const sprintToUse =
                sprints.find((s) => s._id === sessionStorage.getItem('sprintId')) ||
                [...sprints].sort(
                  (a, b) => new Date(b.endDate || 0) - new Date(a.endDate || 0),
                )[0];
              if (sprintToUse) {
                await handleSprintForStandup(sprintToUse._id);
              } else {
                dispatch(setLoading(false));
                dispatch(setLoadingEngMetrics(false));
              }
            } else {
              const selection = resolveDefaultSprintOrRelease({
                boardType: resolveNavBoardType(),
                sprintList: sprints,
                releaseList: releases,
              });
              if (selection.mode === 'release' && selection.release) {
                dispatch(
                  setSelectedTypeValue({
                    selectedValueLabel: selection.releaseLabel,
                    selectedValue: APP_STRINGS.VALUE_RELEASE,
                  }),
                );
                await handleReleaseForStandup(selection.release._id);
              } else if (selection.mode === 'sprint' && selection.sprint) {
                await handleSprintForStandup(selection.sprint._id);
                dispatch(
                  setSelectedTypeValue({
                    selectedValueLabel: selection.sprintLabel,
                    selectedValue: APP_STRINGS.VALUE_SPRINT,
                  }),
                );
              } else {
                dispatch(setLoading(false));
                dispatch(setLoadingEngMetrics(false));
              }
            }
          }
        } catch (err) {
          console.error('Error fetching standup data when leaving dashboard:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // When navigating to QMetry360 dashboard from any other page:
    // reuse Redux CXO + Jira scope cache when it matches the current session (same as Standup).
    // Only refetch when cache is missing/mismatched.
    const isNavigatingToDashboard = currPath === DASHBOARD_PATH && lastPath !== DASHBOARD_PATH;
    const idsMatch = (a, b) =>
      a != null && b != null && String(a) !== '' && String(b) !== '' && String(a) === String(b);
    const isReleaseModeNav =
      typeValueForNav === APP_STRINGS.VALUE_RELEASE || (Boolean(releaseId) && !sprintId);

    if (isNavigatingToDashboard && projectId && boardId && (sprintId || releaseId)) {
      const navState = store.getState();
      const navJira = navState.jira || {};
      const navCxo = navState.cxo || {};
      const sessionReleaseId = sessionStorage.getItem('releaseId');
      // Type-aware: release mode must match release payload (stale Sprint must not count).
      const hasMatchingJiraScope =
        String(navJira?.selectedProjectId || '') === String(projectId || '') &&
        (isReleaseModeNav
          ? idsMatch(navJira?.selectedReleaseId, sessionReleaseId) && Boolean(navJira?.Release)
          : idsMatch(navJira?.selectedSprintId, sprintId) && Boolean(navJira?.Sprint));
      const cachedCxo = navCxo?.releaseReadinessData;
      const hasCachedCxoData = Boolean(
        cachedCxo?.savedCXO ||
          (cachedCxo && typeof cachedCxo === 'object' && Object.keys(cachedCxo).length > 0),
      );

      if (hasMatchingJiraScope && hasCachedCxoData && !navJira?.loading) {
        sessionStorage.setItem('lastVisitedPath', currPath);
        return;
      }

      const typeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
      (async () => {
        try {
          // Reuse list cache on revisit; forceRefresh only when scope payload is missing.
          const forceRefresh = !hasMatchingJiraScope;
          if (typeValue === APP_STRINGS.VALUE_RELEASE && releaseId) {
            await handleRelease(releaseId, forceRefresh);
          } else if (sprintId) {
            await handleSprint(sprintId, undefined, forceRefresh);
          } else if (releaseId) {
            await handleRelease(releaseId, forceRefresh);
          }
        } catch (err) {
          console.error('Error fetching dashboard data on navigation:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // Skip refetch when Redux already has matching Standup card payloads (not merely dashboard Sprint).
    // Dashboard Sprint/Release objects must not suppress Standup API loads.
    const isNavigatingToStandup = currPath === STANDUP_PATH;
    const state = store.getState();
    const jiraData = state.jira || {};
    const sessionReleaseIdForCache = sessionStorage.getItem('releaseId');
    const hasStandupCardPayload = Boolean(
      jiraData?.jiraStatusByDeveloper ||
        jiraData?.standupBurndown ||
        jiraData?.standupVisibility,
    );
    const hasMatchingReleaseCache =
      Boolean(sessionReleaseIdForCache) &&
      idsMatch(jiraData?.selectedReleaseId, sessionReleaseIdForCache) &&
      Boolean(jiraData?.Release) &&
      hasStandupCardPayload;
    const hasMatchingSprintCache =
      Boolean(sprintId) &&
      idsMatch(jiraData?.selectedSprintId, sprintId) &&
      Boolean(jiraData?.Sprint) &&
      hasStandupCardPayload;
    const hasMatchingCachedData =
      String(jiraData?.selectedProjectId || '') === String(projectId || '') &&
      Boolean(projectId) &&
      (isReleaseModeNav ? hasMatchingReleaseCache : hasMatchingSprintCache) &&
      !jiraData?.loading &&
      !jiraData?.loadingEngMetrics;

    const shouldSkipRefetch =
      hasMatchingCachedData &&
      !isStandupNeedingSprint &&
      !isStandupNeedingProject &&
      !shouldBootstrapStandupDefaults &&
      !isDashboardNeedingSprint &&
      (isNavigatingToStandup || isLeavingTechQuality);

    // Login seeds project/sprint/release IDs but clears metric payloads via setSelectedProject.
    // When scope IDs exist without Standup card payloads, bootstrap Stand-up fetches.
    // Dashboard Sprint alone is not enough (different API payloads).
    const isStandupMissingCardData =
      isNavigatingToStandup &&
      projectId &&
      (sprintId || releaseId) &&
      !jiraData?.loadingEngMetrics &&
      !hasStandupCardPayload;

    if (isStandupMissingCardData) {
      const typeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
      (async () => {
        try {
          const sessionProjectName = sessionStorage.getItem('projectName') || '';
          if (
            projectId &&
            String(store.getState()?.jira?.selectedProjectId || '') !== String(projectId)
          ) {
            dispatch(
              setSelectedProject({
                selectedProjectName: sessionProjectName,
                selectedProjectId: projectId,
              }),
            );
          }
          await ensureBoardForProject(companyIdForNav, projectId);
          if (typeValue === APP_STRINGS.VALUE_RELEASE && releaseId) {
            await handleReleaseForStandup(releaseId);
          } else if (sprintId) {
            await handleSprintForStandup(sprintId);
          } else if (releaseId) {
            await handleReleaseForStandup(releaseId);
          }
        } catch (err) {
          console.error('Error bootstrapping Stand-up card data:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // Leaving Tech Quality with valid cache: keep current sprint/release selection (no loading).
    if (isLeavingTechQuality && shouldSkipRefetch) {
      sessionStorage.setItem('lastVisitedPath', currPath);
      return;
    }

    // Leaving Tech Quality while Release is selected: keep/re-fetch that release — do not force active sprint.
    if (isLeavingTechQuality && isReleaseModeNav && releaseId && projectId && boardId && !shouldSkipRefetch) {
      sessionStorage.setItem('lastVisitedPath', currPath);
      if (
        idsMatch(jiraData?.selectedReleaseId, releaseId) &&
        jiraData?.Release &&
        !jiraData?.loading &&
        !jiraData?.loadingEngMetrics
      ) {
        return;
      }
      (async () => {
        try {
          if (currPath === STANDUP_PATH) {
            await handleReleaseForStandup(releaseId);
          } else if (currPath === DASHBOARD_PATH) {
            await handleRelease(releaseId);
          } else {
            await handleRelease(releaseId);
          }
        } catch (err) {
          console.error('Error restoring release after leaving Tech Quality:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
      return;
    }

    if (
      (isLeavingTechQuality ||
        isDashboardNeedingSprint ||
        isStandupNeedingSprint ||
        isStandupNeedingProject ||
        shouldBootstrapStandupDefaults) &&
      (projectId || isStandupNeedingProject || shouldBootstrapStandupDefaults) &&
      !shouldSkipRefetch
    ) {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      (async () => {
        try {
          let activeProjectId = projectId || String(reduxProjectId || '');
          const companyId = companyIdForNav;

          if (activeProjectId) {
            const sessionProjectName =
              sessionStorage.getItem('projectName') ||
              store.getState()?.jira?.selectedProjectName ||
              '';
            if (
              String(store.getState()?.jira?.selectedProjectId || '') !== String(activeProjectId)
            ) {
              dispatch(
                setSelectedProject({
                  selectedProjectName: sessionProjectName,
                  selectedProjectId: activeProjectId,
                }),
              );
            }
          }

          if (!activeProjectId) {
            let projectList = store.getState()?.jira?.projectList;
            if (!Array.isArray(projectList) || projectList.length === 0) {
              const projectsRes = await getProjectList();
              projectList = Array.isArray(projectsRes?.data)
                ? projectsRes.data
                : Array.isArray(projectsRes)
                  ? projectsRes
                  : [];
              if (projectList.length > 0) {
                dispatch(setProjectList(projectList));
              }
            }
            const firstProject = pickDefaultProjectForBootstrap(projectList);
            if (!firstProject?._id) {
              // Stay on Standup so the user can switch workspace — do not keep redirecting.
              sessionStorage.removeItem('sprintId');
              sessionStorage.removeItem('releaseId');
              clearLoadersNoProject(dispatch);
              return;
            }
            activeProjectId = String(firstProject._id);
            sessionStorage.setItem('projectId', activeProjectId);
            sessionStorage.setItem('projectName', firstProject.name);
            dispatch(
              setSelectedProject({
                selectedProjectName: firstProject.name,
                selectedProjectId: activeProjectId,
              }),
            );
            try {
              await refreshScopedPermissions(companyId, activeProjectId);
            } catch (permErr) {
              console.error('Failed to refresh permissions for default Standup project:', permErr);
            }
            sessionStorage.removeItem('boardId');
            sessionStorage.removeItem(APP_STRINGS.SESSION_BOARD_ID);
            sessionStorage.removeItem(APP_STRINGS.SESSION_SELECTED_BOARD);
            sessionStorage.removeItem(BOARD_SCOPE_PROJECT_KEY);
            await ensureBoardForProject(companyId, activeProjectId);
            await handleProject(
              activeProjectId,
              sessionStorage.getItem('boardType') ||
                sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
                '',
              dispatch,
            );
            return;
          }

          // Project known but sprint/release missing (typical after Admin → Standup): full handleProject
          if (
            shouldBootstrapStandupDefaults &&
            !sprintId &&
            !releaseId &&
            typeValueForNav !== APP_STRINGS.VALUE_BACKLOG
          ) {
            await ensureBoardForProject(companyId, activeProjectId);
            await handleProject(
              activeProjectId,
              sessionStorage.getItem('boardType') ||
                sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
                '',
              dispatch,
            );
            return;
          }

          const { boardId: resolvedBoardId, boardType } = await ensureBoardForProject(
            companyId,
            activeProjectId,
          );
          if (!resolvedBoardId) {
            dispatch(setLoading(false));
            dispatch(setLoadingEngMetrics(false));
            return;
          }

          const cachedSprints = store.getState()?.jira?.sprintList;
          let sprints =
            Array.isArray(cachedSprints) && cachedSprints.length > 0
              ? cachedSprints
              : (await getSprintList())?.data || [];
          if (!Array.isArray(cachedSprints) || cachedSprints.length === 0) {
            dispatch(setSprintList(sprints));
          }

          const cachedReleases = store.getState()?.jira?.releasesList;
          let releases =
            Array.isArray(cachedReleases) && cachedReleases.length > 0
              ? cachedReleases
              : (await getReleaseDetails())?.data || [];
          if (!Array.isArray(cachedReleases) || cachedReleases.length === 0) {
            dispatch(setReleasesList(releases));
          }

          const selection = resolveDefaultSprintOrRelease({
            boardType: boardType || sessionStorage.getItem('boardType') || '',
            sprintList: sprints,
            releaseList: releases,
          });

          if (selection.mode === 'release' && selection.release) {
            dispatch(
              setSelectedTypeValue({
                selectedValueLabel: selection.releaseLabel,
                selectedValue: APP_STRINGS.VALUE_RELEASE,
              }),
            );
            if (currPath === STANDUP_PATH) {
              await handleReleaseForStandup(selection.release._id);
            } else {
              await handleRelease(selection.release._id);
            }
            return;
          }

          if (selection.mode === 'sprint' && selection.sprint) {
            if (currPath === STANDUP_PATH) {
              await handleSprintForStandup(selection.sprint._id);
            } else {
              await handleSprint(selection.sprint._id);
            }
            dispatch(
              setSelectedTypeValue({
                selectedValueLabel: selection.sprintLabel,
                selectedValue: APP_STRINGS.VALUE_SPRINT,
              }),
            );
            return;
          }

          resetData();
          sessionStorage.removeItem('sprintId');
          sessionStorage.removeItem('sprintName');
          sessionStorage.removeItem('releaseId');
          sessionStorage.removeItem('releaseName');
          sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
          sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
          dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
          dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
          dispatch(setSprint(null));
          dispatch(setRelease(null));
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        } catch (err) {
          console.error('Error syncing sprint on leave Tech Quality:', err);
          dispatch(setLoading(false));
          dispatch(setLoadingEngMetrics(false));
        }
      })();
    }

    sessionStorage.setItem('lastVisitedPath', currPath);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, dispatch]);

  const handleOrganization = async (value, dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setSelectedDeveloperName(''));
      sessionStorage.removeItem('repo');
      sessionStorage.removeItem('developer');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.removeItem('projectId');
      store.dispatch(resetGit());
      const cachedOrgsBeforeReset = store.getState()?.jira?.organizationList;
      store.dispatch(resetJira());
      store.dispatch(resetCXO());
      store.dispatch(resetSonarQubeData());
      const organizations =
        cachedOrgsBeforeReset?.length > 0 ? cachedOrgsBeforeReset : await getAllOrgsListAPI();
      if (Array.isArray(organizations) && organizations.length > 0) {
        dispatch(setOrganizationList(organizations));
      }

      const selectedOrg = organizations.find((org) => org._id === value);
      sessionStorage.setItem('companyId', selectedOrg._id);
      sessionStorage.setItem('orgId', selectedOrg._id);
      sessionStorage.setItem('orgName', selectedOrg.companyName);

      dispatch(
        setSelectedOrganization({
          selectedOrgName: selectedOrg.companyName,
          selectedOrgId: selectedOrg._id,
        }),
      );

      dispatch(setIsOrganizationOpen(false));
      dispatch(setLoading(true));
      await fetchData(getProjectList, setProjectList, { companyId: selectedOrg._id });
      // Auto-select first Integration-enabled project (isSelected) for this org
      const rawProjectList = store.getState()?.jira?.projectList;
      const projectsAfterOrg = Array.isArray(rawProjectList)
        ? rawProjectList
        : rawProjectList?.data || [];
      const firstProject = pickDefaultProjectForBootstrap(projectsAfterOrg);
      if (firstProject?._id) {
        sessionStorage.setItem('projectId', firstProject._id);
        sessionStorage.setItem('projectName', firstProject.name);
        dispatch(
          setSelectedProject({
            selectedProjectName: firstProject.name,
            selectedProjectId: firstProject._id,
            sonarQubeCombinedScanReport: firstProject.combinedScanData,
          }),
        );
        try {
          await refreshScopedPermissions(selectedOrg._id, firstProject._id);
        } catch (permErr) {
          console.error('Failed to refresh permissions for organization project:', permErr);
        }
        sessionStorage.removeItem('boardId');
        sessionStorage.removeItem(APP_STRINGS.SESSION_BOARD_ID);
        sessionStorage.removeItem(APP_STRINGS.SESSION_SELECTED_BOARD);
        sessionStorage.removeItem(BOARD_SCOPE_PROJECT_KEY);
        await ensureBoardForProject(selectedOrg._id, firstProject._id);
        await handleProject(
          firstProject._id,
          sessionStorage.getItem('boardType') ||
            sessionStorage.getItem(APP_STRINGS.SESSION_BOARD_TYPE) ||
            '',
          dispatch,
        );
      } else {
        try {
          await refreshScopedPermissions(selectedOrg._id, null);
        } catch (permErr) {
          console.error('Failed to refresh permissions for organization:', permErr);
        }
        redirectWorkspaceNotIntegrated(dispatch, navigate, location.pathname);
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.error('Error fetching data on project change:', error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };
  const handleProject = async (value, boardType = null, dispatch) => {
    if (location.pathname === RELEASE_DASHBOARD_PATH) {
      await handleProjectForReleaseDashboard(value, boardType, dispatch);
      return;
    }
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setSelectedDeveloperName(''));
      sessionStorage.removeItem('repo');
      sessionStorage.removeItem('developer');
      store.dispatch(resetGit());
      store.dispatch(resetCXO());
      store.dispatch(resetSonarQubeData());
      sessionStorage.removeItem('repo');
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
      sessionStorage.removeItem('developer');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      let projects = [];
      const projectList = store.getState()?.jira?.projectList;
      if (projectList === null || projectList === undefined || projectList?.length === 0) {
        const projectsData = await getProjectList();
        projects = Array.isArray(projectsData?.data)
          ? projectsData.data
          : Array.isArray(projectsData)
            ? projectsData
            : [];
        dispatch(setProjectList(projects));
      } else {
        projects = Array.isArray(projectList) ? projectList : [];
      }
      // Server ObjectIds / session strings often mismatch with === — coerce both sides.
      let selectedProject =
        projects.find((project) => String(project?._id) === String(value || '')) || null;
      // Stale session projectId after login→Admin→Standup: fall back to Integration default.
      if (!selectedProject && projects.length > 0) {
        selectedProject = pickDefaultProjectForBootstrap(projects);
      }
      let repositoryPlatform;
      if (
        selectedProject?.repos &&
        Array.isArray(selectedProject?.repos) &&
        selectedProject?.repos.length > 0
      ) {
        const isGitLab = selectedProject?.repos.some(
          (repo) => typeof repo === 'string' && repo.includes('gitlab.com'),
        );
        const isGitHub = selectedProject?.repos.some(
          (repo) => typeof repo === 'string' && repo.includes('github.com'),
        );

        if (isGitLab) {
          repositoryPlatform = 'GitLab';
        } else if (isGitHub) {
          repositoryPlatform = 'GitHub';
        } else {
          repositoryPlatform = 'unknown';
        }
      }
      dispatch(setRepositoryProvider({ repositoryProvider: repositoryPlatform }));
      if (!selectedProject) {
        throw new Error('Selected project not found');
      }
      const nextProjectId = String(selectedProject._id);
      sessionStorage.setItem('projectId', nextProjectId);
      sessionStorage.setItem('projectName', selectedProject.name);
      if (boardType) {
        const normalized = String(boardType).toLowerCase();
        sessionStorage.setItem(
          'boardType',
          normalized === 'azure board' ||
            normalized === 'azure-board' ||
            normalized.includes('azure')
            ? 'azure-board'
            : normalized,
        );
      }

      // Refresh privileges BEFORE Redux project change so stale in-flight requests
      // for the previous project (same org) cannot win the race.
      try {
        await refreshScopedPermissions(sessionStorage.getItem('companyId'), nextProjectId);
      } catch (permErr) {
        console.error('Failed to refresh permissions for project:', permErr);
      }

      await ensureBoardForProject(sessionStorage.getItem('companyId'), nextProjectId);

      dispatch(
        setSelectedProject({
          selectedProjectName: selectedProject.name,
          selectedProjectId: nextProjectId,
          sonarQubeCombinedScanReport: selectedProject.combinedScanData,
        }),
      );
      dispatch(setSelectedRelease({}));
      dispatch(setIsProjectOpen(false));

      try {
        if (!canAccessPath(location.pathname)) {
          navigate(getDefaultAllowedPath(), { replace: true });
        }
      } catch {
        /* ignore */
      }

      const listFetchParams = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: selectedProject._id,
        boardId: sessionStorage.getItem('boardId'),
      };
      dispatch(setSprintList([]));
      dispatch(setReleasesList([]));
      await Promise.all([
        fetchData(getSprintList, setSprintList, listFetchParams),
        fetchData(getReleaseDetails, setReleasesList, listFetchParams),
        fetchData(getRepoList, setRepoList, {
          companyId: sessionStorage.getItem('companyId'),
          projectId: selectedProject._id,
        }),
      ]);

      const state = store.getState();
      const jiraData = state.jira;
      let latestUnreleasedRelease, currentSprint;
      const isAzure = String(sessionStorage.getItem('boardType') || boardType || '')
        .toLowerCase()
        .includes('azure');
      const isGitLab = String(sessionStorage.getItem('boardType') || boardType || '')
        .toLowerCase()
        .includes('gitlab');
      const isGithubBoard = String(sessionStorage.getItem('boardType') || boardType || '')
        .toLowerCase()
        .includes('github');
      // const labelSprint = isAzure ? 'Iteration' : 'Sprint';
      const labelRelease = isGitLab
        ? APP_STRINGS.LABEL_MILESTONE
        : isGithubBoard
          ? APP_STRINGS.LABEL_MILESTONE
          : isAzure
            ? APP_STRINGS.LABEL_EPIC
            : APP_STRINGS.VALUE_RELEASE;
      const boardTypeKey = String(
        boardType || sessionStorage.getItem('boardType') || '',
      ).toLowerCase();
      const sprintList = jiraData?.sprintList || [];
      const releaseList = jiraData?.releasesList || [];
      // getBoardList often returns boardType "simple" for both Scrum (with sprints) and release-only boards.
      // Default Release when: Kanban/GitLab, no sprints, or simple board without an active sprint.
      const useReleaseDefault = shouldDefaultToRelease({
        boardType: boardTypeKey,
        sprintList,
        releaseList,
      });
      if (useReleaseDefault) {
        latestUnreleasedRelease = pickDefaultRelease(releaseList);

        if (latestUnreleasedRelease) {
          sessionStorage.setItem('releaseId', latestUnreleasedRelease._id);
          dispatch(
            setSelectedTypeValue({
              selectedValueLabel: labelRelease,
              selectedValue: APP_STRINGS.VALUE_RELEASE,
            }),
          );
          dispatch(
            setSelectedRelease({
              selectedReleaseId: latestUnreleasedRelease._id,
              selectedReleaseName: latestUnreleasedRelease.releaseName,
            }),
          );
        }
      } else {
        const list = jiraData?.sprintList;
        currentSprint = pickDefaultSprint(list, {
          boardType: boardTypeKey,
          storedSprintId: sessionStorage.getItem('sprintId'),
        });
        if (currentSprint) {
          sessionStorage.setItem('sprintId', currentSprint._id);
          const { sprintLabel } = getBoardLabels({ boardType });
          dispatch(
            setSelectedTypeValue({
              selectedValueLabel: sprintLabel,
              selectedValue: APP_STRINGS.VALUE_SPRINT,
            }),
          );
          dispatch(
            setSelectedSprint({
              selectedSprintId: currentSprint._id,
              selectedSprintName: currentSprint.name,
            }),
          );
        }
      }
      repo = null;
      if (Array.isArray(jiraData.repoList) && jiraData.repoList.length > 0) {
        const defaultRepo = [...jiraData.repoList].sort()[0];
        dispatch(setSelectedRepository(defaultRepo));
        sessionStorage.setItem('repo', defaultRepo);
        repo = defaultRepo;
      }
      if (useReleaseDefault) {
        if (latestUnreleasedRelease) {
          await handleRelease(latestUnreleasedRelease._id);
        }
      } else {
        if (currentSprint) {
          await handleSprint(currentSprint._id);
        }
      }
    } catch (error) {
      console.error('Error fetching data on project change:', error);
      const currentProjectId = sessionStorage.getItem('projectId');
      const currentProjectName = sessionStorage.getItem('projectName');

      if (!currentProjectId || !currentProjectName) {
        dispatch(setSelectedProject({ selectedProjectName: '', selectedProjectId: '' }));
        sessionStorage.removeItem('projectId');
        sessionStorage.removeItem('projectName');
      }
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };
  const getSonarQubeReportByRepo = (data, repoName) => {
    const sonarQubeScanReports =
      data?.savedCXO?.engineeringScoreObject?.developerScoreObject?.sonarQubeScanReport;
    const report = sonarQubeScanReports?.find((report) => {
      const repoLastName = report.repo.split('/').pop();
      return repoLastName === repoName;
    });
    dispatch(addData(report));
  };

  const updateCapacityValues = async (value, state) => {
    if (state === APP_STRINGS.VALUE_SPRINT) {
      const sprints = await getSprintList();
      const list = sprints.data || [];
      dispatch(setSprintList(list));
      const selectedSprint = list.find((sprint) => String(sprint._id) === String(value));
      if (selectedSprint) dispatch(setSprint(selectedSprint));
    } else if (state === APP_STRINGS.VALUE_RELEASE) {
      const releases = await getReleaseDetails();
      const list = releases.data || [];
      dispatch(setReleasesList(list));
      const selectedRelease = list.find((release) => String(release._id) === String(value));
      if (selectedRelease) dispatch(setRelease(selectedRelease));
    }
  };

  const fetchProjectManagementData = async (query, sections = null) => {
    try {
      const apiQuery = { ...query };
      if (sections) {
        apiQuery.sections = sections;
      }
      const response = await getProjectManagementData(apiQuery);
      const data = response.data;
      if (!data) {
        return;
      }

      const sectionActionMap = {
        velocity: setVelocityData,
        taskCount: setTaskCountData,
        statusCount: setStatusCountData,
        defectDensity: setDefectDensity,
        spCommittedVsCompleted: setStoryPointsData,
        bugClassification: setBugClassification,
        defectRejection: setDefectRejection,
        defectRemovalEfficiency: setDefectRemovalEfficiency,
        timeToFix: setTimeToFix,
        cycleTime: setCycleTime,
        burndownData: setBurndownData,
        actualStoryPoints: setActualStoryPoints,
        burndownVelocity: setBurndownVelocity,
        // dailyBurnup and storyChurn are handled by fetchStandupDashboardData to avoid race condition
        // (PM endpoint uses different logic files than the standup endpoint for these sections)
        defectLeakage: setDefectLeakageAnalysis,
        costOfFixing: setCostOfFixingDefect,
        sprintLength: setSprintLength,
        qaInsightsBugs: setQAInsightsBugsData,
        qaInsightsTests: setQAInsightsTestsData,
        qaReference: setQAReferenceData,
        storyPointData: setGetStoryPointData,
        availableHours: setAvailableHours,
        sprintCompleteDate: setSprintCompleteDate,
        userList: setUserList,
      };

      for (const [key, action] of Object.entries(sectionActionMap)) {
        if (data[key] !== undefined) {
          dispatch(action(data[key]));
        }
      }
    } catch (error) {
      console.error('Error fetching project management data:', error);
    }
  };

  const fetchStandupDashboardData = async (query, sections = null) => {
    try {
      const apiQuery = { ...query };
      if (sections) {
        apiQuery.sections = sections;
      }
      const response = await getStandupDashboardData(apiQuery);
      const data = response.data;
      if (!data) {
        return;
      }

      const sectionActionMap = {
        jiraData: setJiraTableData,
        jiraStatusByDev: setJiraStatusByDeveloper,
        standupBurndown: setStandupBurndown,
        dailyWiseStatusCount: setDailyWiseStatusCount,
        openPRs: setStandupOpenPRsData,
        mergedWithoutReview: setStandupMergedPRsData,
        // qaInsightsBugs, qaInsightsTests, qaReference are handled by fetchProjectManagementData to avoid race condition
        // (PM endpoint uses boardId-scoped logic; standup endpoint uses different logic without boardId)
        dailyBurnup: setDailyBurnup,
      };

      for (const [key, action] of Object.entries(sectionActionMap)) {
        if (data[key] !== undefined) {
          dispatch(action(data[key]));
        }
      }

      const excludeBugs = sessionStorage.getItem('excludeBugsInChurn') === 'true';
      const churnKey = excludeBugs ? 'storyChurnExcludingBugs' : 'storyChurn';
      if (data[churnKey] !== undefined) {
        dispatch(setStoryChurnData(data[churnKey]));
      }
      if (data.visibility !== undefined) {
        dispatch(setStandupVisibility(data.visibility));
      }
      if (data.getmultiProjectfilters !== undefined) {
        dispatch(setMultiProjectFilters(data.getmultiProjectfilters));
        const activeCompanyId = sessionStorage.getItem('companyId');
        if (activeCompanyId) {
          dispatch(setMultiProjectCompanyId(activeCompanyId));
        }
      }
    } catch (error) {
      console.error('Error fetching standup dashboard data:', error);
    }
  };

  const fetchGitDashboardData = async (query, sections = null) => {
    try {
      const apiQuery = { ...query };
      if (sections) {
        apiQuery.sections = sections;
      }
      const response = await getGitDashboardData(apiQuery);
      const data = response.data;
      if (!data) {
        return;
      }

      const sectionActionMap = {
        closedPRs: setClosedPRs,
        openPRs: setOpenPRs,
        totalPRs: setTotalPRs,
        mergedWithoutReview: setMergedWithoutReviewPRs,
        prSize: setPRSize,
        gitCycleTime: setGitCycleTime,
        approvalRate: setApprovalRate,
        iterationTime: setIterationTime,
        leadTime: setLeadTimeChanges,
        doraMetrics: setGetDoraData,
      };

      for (const [key, action] of Object.entries(sectionActionMap)) {
        if (data[key] !== undefined) {
          dispatch(action(data[key]));
        }
      }
    } catch (error) {
      console.error('Error fetching git dashboard data:', error);
    }
  };

  const fetchCXODashboardData = async (query, sections = null) => {
    try {
      const apiQuery = { ...query };
      if (sections) {
        apiQuery.sections = sections;
      }
      const response = await getCXODashboardData(apiQuery);
      const data = response.data;
      if (!data) {
        return;
      }

      if (data.cxoData !== undefined) {
        dispatch(addReleaseReadinessData(data.cxoData));
      }
      if (data.cxoTrends !== undefined) {
        dispatch(addReleaseReadinessTrendsData(data.cxoTrends));
      }
    } catch (error) {
      console.error('Error fetching CXO dashboard data:', error);
    }
  };

  /** Stand-up PR table + summary for toolbar "Date Range" (no sprint/release). */
  const handleDateRangeForStandup = async (startDateStr, endDateStr) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setQAReferenceData(null));
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.setItem('standupPrStartDate', startDateStr);
      sessionStorage.setItem('standupPrEndDate', endDateStr);
      sessionStorage.setItem('standupIssueCreatedStartDate', startDateStr);
      sessionStorage.setItem('standupIssueCreatedEndDate', endDateStr);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_DATE_RANGE);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_DATE_RANGE);
      dispatch(
        setSelectedTypeValue({
          selectedValueLabel: APP_STRINGS.VALUE_DATE_RANGE,
          selectedValue: APP_STRINGS.VALUE_DATE_RANGE,
        }),
      );
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      dispatch(setSprint(null));
      dispatch(setRelease(null));
      const matchDateRangeQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        repo: sessionStorage.getItem('repo'),
        developer: sessionStorage.getItem('developer'),
        value: APP_STRINGS.API_SPRINT,
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
      };
      await fetchStandupDashboardData(
        matchDateRangeQuery,
        'jiraData,jiraStatusByDev,standupBurndown,openPRs,mergedWithoutReview,storyChurn,storyChurnExcludingBugs,dailyBurnup',
      );
    } catch (err) {
      console.error('Error fetching Standup data for date range:', err);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  /** When the user clears the date range picker: drop session dates and empty PR table + summary state. */
  const clearStandupPrDateRange = () => {
    sessionStorage.removeItem('standupPrStartDate');
    sessionStorage.removeItem('standupPrEndDate');
    sessionStorage.removeItem('standupIssueCreatedStartDate');
    sessionStorage.removeItem('standupIssueCreatedEndDate');
    dispatch(setTaskCountData([]));
    dispatch(setJiraStatusByDeveloper(null));
    dispatch(
      setJiraTableData({
        issues: [],
        PRsData: [],
        prDateRangeActive: true,
        sourceManagement: 'NA',
      }),
    );
  };

  /** Fetches only APIs required for Standup page - avoids unnecessary Jira/Git/CXO dashboard APIs */
  const handleSprintForStandup = async (value, forceRefresh = false) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setQAReferenceData(null));
      // Drop previous Release/Sprint card payloads so Churn/Jira don't stay empty/stale mid-fetch.
      dispatch(setStoryChurnData(null));
      dispatch(setJiraStatusByDeveloper(null));
      dispatch(setJiraTableData(null));
      sessionStorage.removeItem('standupPrStartDate');
      sessionStorage.removeItem('standupPrEndDate');
      sessionStorage.removeItem('standupIssueCreatedStartDate');
      sessionStorage.removeItem('standupIssueCreatedEndDate');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      const cachedSprints = forceRefresh ? [] : store.getState()?.jira?.sprintList;
      const cachedSelected = (cachedSprints || []).find((sprint) => sprint._id === value);
      const needsFreshSprintList =
        forceRefresh ||
        !Array.isArray(cachedSprints) ||
        cachedSprints.length === 0 ||
        String(cachedSelected?.state || '').toLowerCase() === 'future';
      const sprints = needsFreshSprintList ? (await getSprintList())?.data || [] : cachedSprints;
      if (Array.isArray(sprints) && sprints.length > 0) {
        dispatch(setSprintList(sprints));
      }
      const selectedSprint = sprints.find((sprint) => sprint._id === value);
      if (!selectedSprint) {
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }
      sessionStorage.setItem('sprintId', selectedSprint._id);
      sessionStorage.setItem('sprintName', selectedSprint.name);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_SPRINT);
      const isAzure = String(sessionStorage.getItem('boardType') || '')
        .toLowerCase()
        .includes('azure');
      const labelSprint = isAzure ? APP_STRINGS.LABEL_ITERATION : APP_STRINGS.VALUE_SPRINT;
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, labelSprint);
      const sprintIsHoursBased = resolveStandupHoursBasedProject(selectedSprint, {
        sprintList: sprints,
      });
      sessionStorage.setItem('isHoursBasedProject', sprintIsHoursBased.toString());
      dispatch(
        setSelectedTypeValue({
          selectedValueLabel: labelSprint,
          selectedValue: APP_STRINGS.VALUE_SPRINT,
          
        }),
      );
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      dispatch(setRelease(null));
      dispatch(
        setSelectedSprint({
          selectedSprintId: selectedSprint._id,
          selectedSprintName: selectedSprint.name,
        }),
      );
      dispatch(setSprint({ ...selectedSprint, hours: sprintIsHoursBased }));
      const matchSprintQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        sprintId: sessionStorage.getItem('sprintId'),
        repo: sessionStorage.getItem('repo'),
        developer: getDeveloperQueryParam(),
        value: APP_STRINGS.API_SPRINT,
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = { ...matchSprintQuery, type: isHoursBasedProject ? 'hours' : 'storyPoints' };

      // const standupFetchPromises = [
      //   fetchData(getUserList, setUserList, { companyId: matchSprintQuery.companyId, projectId: matchSprintQuery.projectId }),
      //   fetchData(getReleaseDetails, setReleasesList, { projectId: matchSprintQuery.projectId, boardId: matchSprintQuery.boardId }),
      //   fetchData(getTaskCount, setTaskCountData, matchSprintQuery),
      //   fetchData(getAllStoryPointsCommittedAndCompleted, setStoryPointsData, matchSprintQuery),
      //   fetchData(getSprintLength, setSprintLength, matchSprintQuery),
      //   fetchData(getActualStoryPoints, setActualStoryPoints, matchSprintQuery),
      //   fetchData(getBurndownData, setBurndownData, matchSprintQuery),
      //   fetchData(getStoryPointData, setGetStoryPointData, matchSprintQuery),
      //   fetchData(getjiraTableData, setJiraTableData, matchSprintQuery),
      //   fetchData(getChurnApi(), setStoryChurnData, matchSprintQuery),
      //   fetchData(getDailyBurnup, setDailyBurnup, matchSprintQuery),
      //   fetchData(getSprintCompleteDate, setSprintCompleteDate, matchSprintQuery),
      //   fetchData(getAvailableHours, setAvailableHours, matchSprintQuery),
      //   fetchData(getBurndownVelocity, setBurndownVelocity, burndownVelocityQuery),
      //   fetchData(getQAInsightsBugs, setQAInsightsBugsData, matchSprintQuery),
      //   fetchData(getQAInsightsTests, setQAInsightsTestsData, matchSprintQuery),
      //   fetchData(getQARefrence, setQAReferenceData, matchSprintQuery),
      //   fetchData(fetchJiraStatusByDeveloper, setJiraStatusByDeveloper, matchSprintQuery),
      // ];
      // await Promise.all(standupFetchPromises);
      const standupFetchPromises = [
        fetchProjectManagementData(matchSprintQuery),
        fetchStandupDashboardData(matchSprintQuery),
      ];
      const cachedReleases = store.getState()?.jira?.releasesList;
      if (!Array.isArray(cachedReleases) || cachedReleases.length === 0) {
        standupFetchPromises.push(
          fetchData(getReleaseDetails, setReleasesList, {
            projectId: matchSprintQuery.projectId,
            boardId: matchSprintQuery.boardId,
          }),
        );
      }
      await Promise.all(standupFetchPromises);
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    } catch (err) {
      console.error('Error fetching Standup data:', err);
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  /** Fetches only APIs required for Standup page when switching releases */
  const handleReleaseForStandup = async (value, forceRefresh = false) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setQAReferenceData(null));
      // Drop previous Sprint/Release card payloads so Churn/Jira don't stay empty/stale mid-fetch.
      dispatch(setStoryChurnData(null));
      dispatch(setJiraStatusByDeveloper(null));
      dispatch(setJiraTableData(null));
      sessionStorage.removeItem('standupPrStartDate');
      sessionStorage.removeItem('standupPrEndDate');
      sessionStorage.removeItem('standupIssueCreatedStartDate');
      sessionStorage.removeItem('standupIssueCreatedEndDate');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      //---Add this chage for UI-Performance-improvement
      const releaseFromStore = forceRefresh ? [] : store.getState()?.jira?.releasesList || [];
      let releases = [];
      if (releaseFromStore.length === 0) {
        releases = (await getReleaseDetails())?.data || [];
      } else {
        releases = releaseFromStore;
      }
      if (Array.isArray(releases) && releases.length > 0) {
        dispatch(setReleasesList(releases));
      }
      const selectedRelease = releases.find((release) => release._id === value);
      if (!selectedRelease) {
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }
      sessionStorage.setItem('releaseId', selectedRelease._id);
      sessionStorage.setItem('releaseName', selectedRelease.releaseName);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_RELEASE);
      const isAzure = String(sessionStorage.getItem('boardType') || '')
        .toLowerCase()
        .includes('azure');
      const labelRelease = isAzure ? APP_STRINGS.LABEL_EPIC : APP_STRINGS.VALUE_RELEASE;
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, labelRelease);
      if (selectedRelease?.hours === true) {
        sessionStorage.setItem('isHoursBasedProject', 'true');
      } else {
        sessionStorage.setItem('isHoursBasedProject', 'false');
        const isAzure = String(sessionStorage.getItem('boardType') || '')
          .toLowerCase()
          .includes('azure');
        // const labelRelease = isAzure ? APP_STRINGS.LABEL_EPIC : APP_STRINGS.VALUE_RELEASE;
        const isGithubBoard = String(sessionStorage.getItem('boardType') || '')
          .toLowerCase()
          .includes('github');
        const labelRelease = isAzure
          ? APP_STRINGS.LABEL_EPIC
          : isGithubBoard
            ? APP_STRINGS.LABEL_MILESTONE
            : APP_STRINGS.VALUE_RELEASE;
        sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, labelRelease);
      }
      dispatch(
        setSelectedTypeValue({
          selectedValueLabel:
            sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL) ||
            APP_STRINGS.VALUE_RELEASE,
          selectedValue: APP_STRINGS.VALUE_RELEASE,
        }),
      );
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSprint(null));
      dispatch(
        setSelectedRelease({
          selectedReleaseId: selectedRelease._id,
          selectedReleaseName: selectedRelease.releaseName,
        }),
      );
      dispatch(setIsSprintOpen(false));
      dispatch(setRelease(selectedRelease));
      const matchReleaseQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        releaseId: sessionStorage.getItem('releaseId'),
        value: APP_STRINGS.API_RELEASE,
        repo: sessionStorage.getItem('repo'),
        developer: getDeveloperQueryParam(),
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = { ...matchReleaseQuery, type: isHoursBasedProject ? 'hours' : 'storyPoints' };

      // const standupReleasePromises = [
      //   fetchData(getUserList, setUserList, { companyId: matchReleaseQuery.companyId, projectId: matchReleaseQuery.projectId }),
      //   fetchData(getReleaseDetails, setReleasesList, { projectId: matchReleaseQuery.projectId, boardId: matchReleaseQuery.boardId }),
      //   fetchData(getTaskCount, setTaskCountData, matchReleaseQuery),
      //   fetchData(getAllStoryPointsCommittedAndCompleted, setStoryPointsData, matchReleaseQuery),
      //   fetchData(getSprintLength, setSprintLength, matchReleaseQuery),
      //   fetchData(getActualStoryPoints, setActualStoryPoints, matchReleaseQuery),
      //   fetchData(getReleaseBurndownData, setBurndownData, matchReleaseQuery),
      //   fetchData(getStoryPointData, setGetStoryPointData, matchReleaseQuery),
      //   fetchData(getjiraTableData, setJiraTableData, matchReleaseQuery),
      //   fetchData(getChurnApi(), setStoryChurnData, matchReleaseQuery),
      //   fetchData(getDailyBurnup, setDailyBurnup, matchReleaseQuery),
      //   fetchData(getAvailableHours, setAvailableHours, matchReleaseQuery),
      //   fetchData(getBurndownVelocity, setBurndownVelocity, burndownVelocityQuery),
      //   fetchData(getQAInsightsBugs, setQAInsightsBugsData, matchReleaseQuery),
      //   fetchData(getQAInsightsTests, setQAInsightsTestsData, matchReleaseQuery),
      //   fetchData(getQARefrence, setQAReferenceData, matchReleaseQuery),
      //   fetchData(fetchJiraStatusByDeveloper, setJiraStatusByDeveloper, matchReleaseQuery),
      // ];
      // await Promise.all(standupReleasePromises);
      const standupReleasePromises = [
        // Below commented for UI-Performance-improvement
        // fetchData(getReleaseDetails(), setReleasesList, { projectId: matchReleaseQuery.projectId, boardId: matchReleaseQuery.boardId }),
        fetchProjectManagementData(
          matchReleaseQuery,
          'userList,availableHours,qaInsightsTests,qaInsightsBugs,qaReference,burndownData,taskCount',
        ),
        fetchStandupDashboardData(matchReleaseQuery),
      ];
      await Promise.all(standupReleasePromises);
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    } catch (err) {
      console.error('Error fetching Standup release data:', err);
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  /** Fetches backlog issues for Standup page (Jira/Scrum boards only) */
  const handleBacklogForStandup = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      dispatch(setQAReferenceData(null));
      sessionStorage.removeItem('standupPrStartDate');
      sessionStorage.removeItem('standupPrEndDate');
      sessionStorage.removeItem('standupIssueCreatedStartDate');
      sessionStorage.removeItem('standupIssueCreatedEndDate');
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_BACKLOG);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_BACKLOG);
      dispatch(
        setSelectedTypeValue({
          selectedValueLabel: APP_STRINGS.VALUE_BACKLOG,
          selectedValue: APP_STRINGS.VALUE_BACKLOG,
        }),
      );
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      dispatch(setSprint(null));
      dispatch(setRelease(null));
      const matchBacklogQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        repo: sessionStorage.getItem('repo'),
        developer: getDeveloperQueryParam(),
        value: APP_STRINGS.API_BACKLOG,
      };
      await fetchStandupDashboardData(matchBacklogQuery, 'jiraData,jiraStatusByDev');
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    } catch (err) {
      console.error('Error fetching Standup backlog data:', err);
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const handleProjectForReleaseDashboard = async (value, boardType = null, dispatch) => {
    try {
      dispatch(setLoading(true));
      sessionStorage.removeItem('repo');
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);

      const projects = await getProjectList();
      const selectedProj = projects.data.find((project) => project._id === value);
      if (!selectedProj) throw new Error('Selected project not found');

      sessionStorage.setItem('projectId', selectedProj._id);
      sessionStorage.setItem('projectName', selectedProj.name);
      if (boardType) {
        const normalized = String(boardType).toLowerCase();
        sessionStorage.setItem(
          'boardType',
          normalized.includes('azure') ? 'azure-board' : normalized,
        );
      }

      try {
        await refreshScopedPermissions(sessionStorage.getItem('companyId'), selectedProj._id);
        if (!canAccessPath(location.pathname)) {
          navigate(getDefaultAllowedPath(), { replace: true });
        }
      } catch (permErr) {
        console.error('Failed to refresh permissions for project:', permErr);
      }

      dispatch(
        setSelectedProject({
          selectedProjectName: selectedProj.name,
          selectedProjectId: selectedProj._id,
        }),
      );
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSprint(null));
      dispatch(setRelease(null));
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      dispatch(setReleasesList([]));
      dispatch(setIsProjectOpen(false));

      await Promise.all([
        fetchData(getSprintList, setSprintList, {
          projectId: selectedProj._id,
          boardId: sessionStorage.getItem('boardId'),
        }),
        fetchData(getReleaseDetails, setReleasesList, {
          projectId: selectedProj._id,
          boardId: sessionStorage.getItem('boardId'),
        }),
      ]);

      const state = store.getState();
      const jiraData = state.jira;

      const latestRelease =
        jiraData?.releasesList
          ?.filter((r) => r.status?.toLowerCase() === 'unreleased')
          .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
          ?.at(0) ||
        (Array.isArray(jiraData?.releasesList) && jiraData.releasesList.length > 0
          ? [...jiraData.releasesList].sort(
              (a, b) => new Date(b.releaseDate) - new Date(a.releaseDate),
            )[0]
          : null);

      if (latestRelease) {
        sessionStorage.setItem('releaseId', latestRelease._id);
        sessionStorage.setItem('releaseName', latestRelease.releaseName);
        sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_RELEASE);
        sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_RELEASE);
        dispatch(
          setSelectedRelease({
            selectedReleaseId: latestRelease._id,
            selectedReleaseName: latestRelease.releaseName,
          }),
        );
      }
    } catch (error) {
      console.error('Error fetching data on project change (release dashboard):', error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const handleReleaseForReleaseDashboard = async (value) => {
    try {
      dispatch(setLoading(true));
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');

      const releases = (await getReleaseDetails())?.data || [];
      const selectedRel = releases.find((release) => release._id === value);
      if (!selectedRel) {
        dispatch(setLoading(false));
        return;
      }

      sessionStorage.setItem('releaseId', selectedRel._id);
      sessionStorage.setItem('releaseName', selectedRel.releaseName);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_RELEASE);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_RELEASE);

      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSprint(null));
      dispatch(
        setSelectedRelease({
          selectedReleaseId: selectedRel._id,
          selectedReleaseName: selectedRel.releaseName,
        }),
      );
      dispatch(setIsSprintOpen(false));
      dispatch(setRelease(selectedRel));
    } catch (error) {
      console.error('Error fetching data on release change (release dashboard):', error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSprint = async (value, pageValue, forceRefresh = false) => {
    if (location.pathname === RELEASE_DASHBOARD_PATH) return;
    if (location.pathname === STANDUP_PATH) {
      await handleSprintForStandup(value, forceRefresh);
      return;
    }
    if (pageValue === undefined || null) {
      pageValue = 7;
    } else {
      pageValue;
    }
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      // Clear QA Reference data when switching sprints
      dispatch(setQAReferenceData(null));
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      const state = store.getState();
      const cachedSprints = forceRefresh ? [] : state?.jira?.sprintList || [];
      const sprints =
        Array.isArray(cachedSprints) && cachedSprints.length > 0
          ? cachedSprints
          : (await getSprintList())?.data || [];
      if (Array.isArray(sprints) && sprints.length > 0) {
        dispatch(setSprintList(sprints));
      }
      const selectedSprint = sprints.find((sprint) => sprint._id === value);
      if (!selectedSprint) {
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }
      sessionStorage.setItem('sprintId', selectedSprint._id);
      sessionStorage.setItem('sprintName', selectedSprint.name);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_SPRINT);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_SPRINT);
      if (selectedSprint?.hours === true) {
        sessionStorage.setItem('isHoursBasedProject', 'true');
      } else {
        sessionStorage.setItem('isHoursBasedProject', 'false');
        {
          const { sprintLabel } = getBoardLabels({});
          sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, sprintLabel);
        }
      }
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      dispatch(setRelease(null));
      dispatch(
        setSelectedSprint({
          selectedSprintId: selectedSprint._id,
          selectedSprintName: selectedSprint.name,
        }),
      );

      dispatch(setSprint(selectedSprint));
      const matchSprintQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        sprintId: sessionStorage.getItem('sprintId'),
        repo: sessionStorage.getItem('repo'),
        developer: getDeveloperQueryParam(),
        value: APP_STRINGS.API_SPRINT,
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const matchSprintQueryForTrends = {
      //   ...matchSprintQuery,
      //   pageValue,
      // };
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = {
      //   ...matchSprintQuery,
      //   type: isHoursBasedProject ? 'hours' : 'storyPoints',
      // };
      // await fetchData(getReleaseReadinessDetails, addReleaseReadinessData, matchSprintQuery);

      const cachedReleasesForSprint = state?.jira?.releasesList;
      if (!Array.isArray(cachedReleasesForSprint) || cachedReleasesForSprint.length === 0) {
        await fetchData(getReleaseDetails, setReleasesList, {
          projectId: matchSprintQuery.projectId,
          boardId: matchSprintQuery.boardId,
        });
      }

      const path = location.pathname;
      const query = matchSprintQuery;

      if (path === DASHBOARD_PATH) {
        // Priority: Dashboard needs CXO Data first
        await fetchCXODashboardData({ ...query, pageValue });
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === JIRA_PATH) {
        // Priority: Engineering (Jira) needs PM Data first
        await fetchProjectManagementData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchCXODashboardData({ ...query, pageValue }),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === STANDUP_PATH) {
        // Priority: Standup page needs Standup Data first
        await fetchStandupDashboardData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchCXODashboardData({ ...query, pageValue }),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === GIT_PATH && repo) {
        // Priority: Git page needs Git Data first
        await fetchGitDashboardData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchCXODashboardData({ ...query, pageValue }),
          fetchStandupDashboardData(query),
        ]);
      } else {
        // Default: Parallelize all if path doesn't match specific priorities
        await Promise.all([
          fetchCXODashboardData({ ...query, pageValue }),
          fetchProjectManagementData(query),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      }

      const endDate = new Date(selectedSprint?.endDate);
      const formattedEndDate = endDate.toLocaleDateString('en-IN');
      setSelectedSprintEndDate({ id: selectedSprint?._id, endDate: formattedEndDate });
      const current_state = store.getState();
      const cxoData = current_state.cxo;
      getSonarQubeReportByRepo(cxoData.releaseReadinessData, repo);
      dispatch(setLoadingEngMetrics(false));
      dispatch(setLoading(false));
    } catch (error) {
      console.error('Error fetching data on sprint change:', error);
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const handleRelease = async (value, forceRefresh = false) => {
    if (location.pathname === RELEASE_DASHBOARD_PATH) {
      await handleReleaseForReleaseDashboard(value);
      return;
    }
    if (location.pathname === STANDUP_PATH) {
      await handleReleaseForStandup(value, forceRefresh);
      return;
    }
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      // Clear QA Reference data when switching releases
      dispatch(setQAReferenceData(null));
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      const state = store.getState();
      let releases = state?.jira?.releasesList || [];
      if (forceRefresh || !Array.isArray(releases) || releases.length === 0) {
        releases = (await getReleaseDetails())?.data || [];
      }
      if (Array.isArray(releases) && releases.length > 0) {
        dispatch(setReleasesList(releases));
      }
      const selectedRelease = releases.find((release) => release._id === value);
      if (!selectedRelease) {
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }
      sessionStorage.setItem('releaseId', selectedRelease._id);
      sessionStorage.setItem('releaseName', selectedRelease.releaseName);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE, APP_STRINGS.VALUE_RELEASE);
      sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, APP_STRINGS.VALUE_RELEASE);
      if (selectedRelease?.hours === true) {
        sessionStorage.setItem('isHoursBasedProject', 'true');
      } else {
        sessionStorage.setItem('isHoursBasedProject', 'false');
        // {
        const isAzure = String(sessionStorage.getItem('boardType') || '')
          .toLowerCase()
          .includes('azure');
        // const labelRelease = isAzure ? APP_STRINGS.LABEL_EPIC : APP_STRINGS.VALUE_RELEASE;
        const isGithubBoard = String(sessionStorage.getItem('boardType') || '')
          .toLowerCase()
          .includes('github');
        const labelRelease = isAzure
          ? APP_STRINGS.LABEL_EPIC
          : isGithubBoard
            ? APP_STRINGS.LABEL_MILESTONE
            : APP_STRINGS.VALUE_RELEASE;
        sessionStorage.setItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL, labelRelease);
        //   }
      }
      dispatch(
        setSelectedTypeValue({
          selectedValueLabel:
            sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL) ||
            APP_STRINGS.VALUE_RELEASE,
          selectedValue: APP_STRINGS.VALUE_RELEASE,
        }),
      );
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSprint(null));
      dispatch(
        setSelectedRelease({
          selectedReleaseId: selectedRelease._id,
          selectedReleaseName: selectedRelease.releaseName,
        }),
      );
      dispatch(setIsSprintOpen(false));
      dispatch(setRelease(selectedRelease));
      dispatch(setDailyBurnup([]));
      const matchReleaseQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        releaseId: sessionStorage.getItem('releaseId'),
        value: APP_STRINGS.API_RELEASE,
        repo: sessionStorage.getItem('repo'),
        developer: getDeveloperQueryParam(),
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = {
      //   ...matchReleaseQuery,
      //   type: isHoursBasedProject ? 'hours' : 'storyPoints',
      // };
      // await fetchData(getReleaseReadinessDetails, addReleaseReadinessData, matchReleaseQuery);

      const path = location.pathname;
      const query = matchReleaseQuery;

      if (path === DASHBOARD_PATH) {
        // Priority: Dashboard needs CXO Data first
        await fetchCXODashboardData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === JIRA_PATH) {
        // Priority: Engineering (Jira) needs PM Data first
        await fetchProjectManagementData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchCXODashboardData(query),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === STANDUP_PATH) {
        // Priority: Standup page needs Standup Data first
        await fetchStandupDashboardData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchCXODashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      } else if (path === GIT_PATH && repo) {
        // Priority: Git page needs Git Data first
        await fetchGitDashboardData(query);
        // Pre-load background data for other pages
        await Promise.all([
          fetchProjectManagementData(query),
          fetchCXODashboardData(query),
          fetchStandupDashboardData(query),
        ]);
      } else {
        // Default: Parallelize all if path doesn't match specific priorities
        await Promise.all([
          fetchCXODashboardData(query),
          fetchProjectManagementData(query),
          fetchStandupDashboardData(query),
          repo ? fetchGitDashboardData(query) : Promise.resolve(),
        ]);
      }

      const releaseDate = new Date(selectedRelease?.releaseDate);
      const formattedReleaseDate = releaseDate.toLocaleDateString('en-IN');
      setSelectedReleaseDate({ id: selectedRelease?._id, releaseDate: formattedReleaseDate });
      const current_state = store.getState();
      const cxoData = current_state.cxo;
      getSonarQubeReportByRepo(cxoData.releaseReadinessData, repo);
      dispatch(setLoadingEngMetrics(false));
      dispatch(setLoading(false));
    } catch (error) {
      console.error('Error fetching data on release change:', error);
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const handleRepo = async (value, dispatch) => {
    try {
      store.dispatch(resetGit());
      resetData();
      dispatch(setSelectedDeveloperName(''));
      sessionStorage.removeItem('developer');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      const repoList = await getRepoList();
      const selectedRepo = repoList?.data?.find((repo) => repo === value.label);
      if (!selectedRepo) {
        console.warn('Selected repo not found in repoList');
        return;
      }
      sessionStorage.setItem('repo', selectedRepo);
      dispatch(setSelectedRepository(selectedRepo));

      const projectId = sessionStorage.getItem('projectId');
      const allSprintsResp = await getSprintList({ projectId });
      const allReleasesResp = await getReleaseDetails({ projectId });

      const allSprints = allSprintsResp?.data || [];
      const allReleases = allReleasesResp?.data || [];

      const currentSprintId = sessionStorage.getItem('sprintId');
      const currentReleaseId = sessionStorage.getItem('releaseId');

      const sprintStillValid = allSprints.some((s) => s._id === currentSprintId);
      const releaseStillValid = allReleases.some((r) => r._id === currentReleaseId);

      if (!sprintStillValid) {
        dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
        sessionStorage.removeItem('sprintId');
        sessionStorage.removeItem('sprintName');
      }

      if (!releaseStillValid) {
        dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
        sessionStorage.removeItem('releaseId');
        sessionStorage.removeItem('releaseName');
      }
    } catch (error) {
      console.error('Error fetching data on repo change:', error);
    }
  };

  const handleDeveloper = async (value) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));

      sessionStorage.setItem('developer', value);
      const typeVal = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
      const isRelease = typeVal === APP_STRINGS.VALUE_RELEASE;
      const isBacklog = typeVal === APP_STRINGS.VALUE_BACKLOG;
      const isDateRange =
        isCreatedDateFilterType(typeVal) &&
        sessionStorage.getItem('standupPrStartDate') &&
        sessionStorage.getItem('standupPrEndDate');

      if (isCreatedDateFilterType(typeVal) && !isDateRange) {
        dispatch(setSelectedDeveloperName({ value }));
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }

      const matchSprintQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        repo: sessionStorage.getItem('repo'),
        value: isBacklog
          ? APP_STRINGS.API_BACKLOG
          : isRelease
            ? APP_STRINGS.API_RELEASE
            : APP_STRINGS.API_SPRINT,
        developer: value,
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
        ...(isDateRange || isBacklog
          ? {}
          : isRelease
            ? { releaseId: sessionStorage.getItem('releaseId') }
            : { sprintId: sessionStorage.getItem('sprintId') }),
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = {
      //   ...matchSprintQuery,
      //   type: isHoursBasedProject ? 'hours' : 'storyPoints',
      // };

      dispatch(setSelectedDeveloperName({ value }));

      const developerPmSections =
        'userList,actualStoryPoints,burndownData,availableHours,burndownVelocity,qaInsightsBugs,qaInsightsTests';
      const standupDevSections =
        'jiraData,jiraStatusByDev,standupBurndown,openPRs,mergedWithoutReview,storyChurn,storyChurnExcludingBugs,dailyBurnup';
      const standupBacklogSections = 'jiraData,jiraStatusByDev';
      const fetchPromises = isBacklog
        ? [fetchStandupDashboardData(matchSprintQuery, standupBacklogSections)]
        : isDateRange
          ? [fetchStandupDashboardData(matchSprintQuery, standupDevSections)]
          : [
              fetchProjectManagementData(matchSprintQuery, developerPmSections),
              fetchStandupDashboardData(matchSprintQuery, standupDevSections),
            ];

      await Promise.all(fetchPromises);
    } catch (error) {
      console.error('Error resetting sprint and release:', error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const handleTeam = async (value) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoadingEngMetrics(true));
      sessionStorage.removeItem('developer');

      const typeVal = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
      const isRelease = typeVal === APP_STRINGS.VALUE_RELEASE;
      const isBacklog = typeVal === APP_STRINGS.VALUE_BACKLOG;
      const isDateRange =
        isCreatedDateFilterType(typeVal) &&
        sessionStorage.getItem('standupPrStartDate') &&
        sessionStorage.getItem('standupPrEndDate');

      if (isCreatedDateFilterType(typeVal) && !isDateRange) {
        dispatch(setSelectedDeveloperName({ value }));
        dispatch(setLoading(false));
        dispatch(setLoadingEngMetrics(false));
        return;
      }

      const matchQuery = {
        companyId: sessionStorage.getItem('companyId'),
        projectId: sessionStorage.getItem('projectId'),
        boardId: sessionStorage.getItem('boardId'),
        repo: sessionStorage.getItem('repo'),
        value: isBacklog
          ? APP_STRINGS.API_BACKLOG
          : isRelease
            ? APP_STRINGS.API_RELEASE
            : APP_STRINGS.API_SPRINT,
        estimationType:
          sessionStorage.getItem('isHoursBasedProject') === 'true' ? 'hours' : 'storyPoints',
        ...(isDateRange || isBacklog
          ? {}
          : isRelease
            ? { releaseId: sessionStorage.getItem('releaseId') }
            : { sprintId: sessionStorage.getItem('sprintId') }),
      };
      // For testing purposes we are using unified endpoints. If they work properly, we will remove the commented code later.
      // const isHoursBasedProject = sessionStorage.getItem('isHoursBasedProject') === 'true';
      // const burndownVelocityQuery = {
      //   ...matchQuery,
      //   type: isHoursBasedProject ? 'hours' : 'storyPoints',
      // };

      dispatch(setSelectedDeveloperName(value != null && value !== '' ? { value } : null));

      const teamPmSections =
        'actualStoryPoints,burndownData,taskCount,storyPointData,availableHours,burndownVelocity,qaInsightsBugs,qaInsightsTests,qaReference';
      const standupTeamSections =
        'jiraData,openPRs,mergedWithoutReview,storyChurn,storyChurnExcludingBugs,dailyBurnup';
      const standupBacklogSections = 'jiraData,jiraStatusByDev';
      const fetchPromises = isBacklog
        ? [fetchStandupDashboardData(matchQuery, standupBacklogSections)]
        : isDateRange
          ? [fetchStandupDashboardData(matchQuery, standupTeamSections)]
          : [
              fetchProjectManagementData(matchQuery, teamPmSections),
              fetchStandupDashboardData(matchQuery, standupTeamSections),
              fetchCXODashboardData(matchQuery, 'cxoData'),
            ];

      await Promise.all(fetchPromises);
    } catch (error) {
      console.error('Error resetting sprint and release:', error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoadingEngMetrics(false));
    }
  };

  const resetData = () => {
    store.dispatch(resetCXO());
    store.dispatch(resetSonarQubeData());
    dispatch(setVelocityData([]));
    dispatch(setBugClassification([]));
    dispatch(setCostOfFixingDefect([]));
    dispatch(setTimeToFix([]));
    dispatch(setDefectDensity([]));
    dispatch(setTaskCountData([]));
    dispatch(setJiraStatusByDeveloper(null));
    dispatch(setStatusCountData([]));
    dispatch(setStoryPointsData([]));
    dispatch(setClosedPRs([]));
    dispatch(setLeadTimeChanges([]));
    dispatch(setTotalPRs([]));
    dispatch(setOpenPRs([]));
    dispatch(setPRSize([]));
    dispatch(setGitCycleTime([]));
    dispatch(setApprovalRate([]));
    dispatch(setMergedWithoutReviewPRs([]));
    dispatch(setDefectRejection([]));
    dispatch(setDefectRemovalEfficiency([]));
    dispatch(setIterationTime([]));
    dispatch(setGetDoraData([]));
    dispatch(setDefectLeakageAnalysis([]));
    dispatch(setGetStoryPointData([]));
    dispatch(setJiraTableData([]));
    dispatch(setSprintLength([]));
    dispatch(setStoryChurnData([]));
    dispatch(setCycleTime([]));
    dispatch(setSprintCompleteDate([]));
    dispatch(setAvailableHours([]));
    dispatch(setUserList([]));
  };
  const handleValue = () => {
    try {
      resetData();
      sessionStorage.removeItem('sprintId');
      sessionStorage.removeItem('sprintName');
      sessionStorage.removeItem('releaseId');
      sessionStorage.removeItem('releaseName');
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE);
      sessionStorage.removeItem(APP_STRINGS.SESSION_TYPE_VALUE_LABEL);
      sessionStorage.removeItem('developer');
      sessionStorage.removeItem('velocityToggleType');
      sessionStorage.removeItem('velocityToggleTypeManual');
      sessionStorage.removeItem('standupPrStartDate');
      sessionStorage.removeItem('standupPrEndDate');
      sessionStorage.removeItem('standupIssueCreatedStartDate');
      sessionStorage.removeItem('standupIssueCreatedEndDate');
      dispatch(setSelectedDeveloperName(''));
      dispatch(setSelectedSprint({ selectedSprintId: '', selectedSprintName: '' }));
      dispatch(setSelectedRelease({ selectedReleaseId: '', selectedReleaseName: '' }));
    } catch (error) {
      console.error('Error resetting sprint and release:', error);
    }
  };

  useEffect(() => {
    if (!refreshToken) return;

    const companyId = sessionStorage.getItem('companyId');
    const projectId = sessionStorage.getItem('projectId');
    const boardId = sessionStorage.getItem('boardId');
    if (!projectId || !boardId) return;

    const typeValue = sessionStorage.getItem(APP_STRINGS.SESSION_TYPE_VALUE);
    const sprintId = sessionStorage.getItem('sprintId');
    const releaseId = sessionStorage.getItem('releaseId');
    const standupStart = sessionStorage.getItem('standupPrStartDate') || '';
    const standupEnd = sessionStorage.getItem('standupPrEndDate') || '';

    const dedupeKey = `${refreshToken}|${companyId || ''}|${projectId}|${boardId}|${typeValue || ''}|${sprintId || ''}|${releaseId || ''}|${standupStart}|${standupEnd}`;
    if (dedupeKey === lastCompletedJiraRefreshTokenEffectKey) {
      return;
    }

    const generation = ++jiraRefreshTokenEffectGeneration;
    jiraRefreshTokenEffectInFlightKey = dedupeKey;

    Promise.resolve()
      .then(async () => {
        if (generation !== jiraRefreshTokenEffectGeneration) return;

        if (isCreatedDateFilterType(typeValue) && standupStart && standupEnd) {
          await handleDateRangeForStandup(standupStart, standupEnd);
        } else if (typeValue === APP_STRINGS.VALUE_BACKLOG) {
          await handleBacklogForStandup();
        } else if (typeValue === APP_STRINGS.VALUE_RELEASE && releaseId) {
          const cachedReleases = store.getState()?.jira?.releasesList;
          const releases =
            Array.isArray(cachedReleases) && cachedReleases.length > 0
              ? cachedReleases
              : (await getReleaseDetails())?.data || [];
          const resolvedReleaseId = resolveReleaseIdAfterSync(releases, releaseId);
          await handleRelease(resolvedReleaseId, true);
        } else if (sprintId) {
          const cachedSprints = store.getState()?.jira?.sprintList;
          const sprints =
            Array.isArray(cachedSprints) && cachedSprints.length > 0
              ? cachedSprints
              : (await getSprintList())?.data || [];
          if (Array.isArray(sprints) && sprints.length > 0 && !cachedSprints?.length) {
            dispatch(setSprintList(sprints));
          }
          const resolvedSprintId = resolveSprintIdAfterSync(sprints, sprintId);
          await handleSprint(resolvedSprintId, undefined, true);
        }
      })
      .finally(() => {
        if (generation !== jiraRefreshTokenEffectGeneration) return;
        if (jiraRefreshTokenEffectInFlightKey === dedupeKey) {
          jiraRefreshTokenEffectInFlightKey = null;
        }
        lastCompletedJiraRefreshTokenEffectKey = dedupeKey;
      });
    // Intentionally refreshToken only: module-level dedupe avoids remount duplicate calls; adding handleRelease/handleSprint would refire every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToken]);

  return {
    handleProject,
    handleSprint,
    handleRelease,
    handleRepo,
    handleValue,
    handleDeveloper,
    handleTeam,
    handleBacklogForStandup,
    handleDateRangeForStandup,
    clearStandupPrDateRange,
    handleOrganization,
    fetchData,
    updateCapacityValues,
    fetchProjectManagementData,
  };
};
export function getMetricValue({
  selectedValue,
  toggleType,
  selectedSprintData,
  selectedReleaseData,
  metricType,
}) {
  const value = typeof selectedValue === 'string' ? selectedValue : selectedValue?.value;
  const sourceData = value === APP_STRINGS.VALUE_SPRINT ? selectedSprintData : selectedReleaseData;
  if (!sourceData) return 0;
  const cleanMetricType = metricType.trim();
  const lowerCaseMetricType = cleanMetricType.toLowerCase();
  let key;
  if (lowerCaseMetricType.includes('storypoints') || lowerCaseMetricType.includes('hours')) {
    key = cleanMetricType;
  } else {
    const suffix = toggleType === APP_STRINGS.STORY_POINTS ? 'StoryPoints' : APP_STRINGS.HOURS;
    key = `${cleanMetricType}${suffix}`;
  }
  return sourceData?.[key] ?? 0;
}

/** Truncate to one decimal place (no round-up). e.g. 38.59 → 38.5, 38.5 → 38.5 */
export function truncateToOneDecimal(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.trunc(n * 10) / 10;
}

/** Display metric with at most one decimal; integers show without trailing .0 */
export function formatMetricOneDecimal(value) {
  const truncated = truncateToOneDecimal(value);
  if (Number.isInteger(truncated)) {
    return String(truncated);
  }
  return truncated.toFixed(1);
}

export function formatNumberWithSuffix(value, decimals = 0) {
  if (value === null || value === undefined || isNaN(value)) {
    return { formatted: '0', original: 0 };
  }

  const num = parseFloat(value);
  const absNum = Math.abs(num);

  if (absNum < 1000) {
    return {
      formatted: num.toString(),
      original: num,
    };
  } else if (absNum < 100000) {
    // For 1,000 to 99,999 - show as K
    const formatted = (num / 1000).toFixed(decimals);
    return {
      formatted: `${formatted}K`,
      original: num,
    };
  } else if (absNum < 10000000) {
    // For 100,000 to 9,999,999 - show as L (Lakhs)
    const formatted = (num / 100000).toFixed(decimals);
    return {
      formatted: `${formatted}L`,
      original: num,
    };
  } else {
    // For 10,000,000 and above - show as M (Millions)
    const formatted = (num / 1000000).toFixed(decimals);
    return {
      formatted: `${formatted}M`,
      original: num,
    };
  }
}
